<template>
  <div class="">
    <vx-card class="overflow-hidden mb-base" title="Statistiques globales" collapse-action>
      <template slot="no-body">
        <stats-summary />
      </template>
    </vx-card>

    <vx-card class="" title="Statistiques" collapse-action>
      <template slot="no-body">
        <stats-details />
      </template>
    </vx-card>
  </div>
</template>

<script>
  import StatsSummary from './partials/StatsSummary';
  import StatsDetails from "./partials/StatsDetails";
  export default {
    name: "customer",
    components: {StatsSummary, StatsDetails}
  }
</script>
